import parse from 'html-react-parser';
import Center from '../../assets/styles/Center';
import DefaultContainer from '../../assets/styles/DefaultContainer';
import Text from '../../assets/styles/Text';
import Error from '../../components/Error';
import Loader from '../../components/Loader';
import { useSettings } from '../../hooks/queries/useSettings';
import * as styles from './styles';

export default function Policies() {
  const { data: settings, isLoading, isError, error } = useSettings();

  if (isLoading) return <Loader isLoading={isLoading} />;

  if (isError) {
    return <Error isError message={error?.message} />;
  }

  return (
    <DefaultContainer>
      <Center className="center">
        <Text.H1 $bold>Politicas de privacidade</Text.H1>

        <styles.Container>{parse(settings.privacyPolicy)}</styles.Container>
      </Center>
    </DefaultContainer>
  );
}
